import { render, staticRenderFns } from "./PhaseWorksheet.vue?vue&type=template&id=0c853260&scoped=true&"
import script from "./PhaseWorksheet.vue?vue&type=script&lang=ts&"
export * from "./PhaseWorksheet.vue?vue&type=script&lang=ts&"
import style0 from "./PhaseWorksheet.vue?vue&type=style&index=0&id=0c853260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c853260",
  null
  
)

export default component.exports